import { NoOption } from '@aibees/elephant/feature/suggestion-search-bar/components/no-option';
import { Grid2 } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { mergeSx } from 'merge-sx';
import { useSuggestionSearchBarContext } from '../../context';
import { SuggestionSearchBarOptionBase } from '../../types';
import { DetailedItem } from '../detailed-item';
import { ItemWrapper } from '../item-wrapper';
import { SingleItem } from '../single-item';
import * as Styled from './styles';
import * as SX from './sx';
import type { OptionsContainerProps as Props } from './types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Stack } from '@mui/material';

export const OptionsContainer = <T extends SuggestionSearchBarOptionBase>({
  className,
  sx,
}: Props<T>) => {
  const { options, getListboxProps, isOptionsLoading } =
    useSuggestionSearchBarContext();

  return (
    <Styled.Wrapper
      className={classnames('OptionsContainer', className)}
      sx={mergeSx(SX.root, sx)}
      {...getListboxProps}
    >
      <Grid2 container columns={12} sx={SX.container}>
        <NoOption />
        {(options.length || isOptionsLoading) && (
          <>
            <Grid2 xs={6} sx={SX.items}>
              <ItemWrapper>
                <Stack direction="column">
                  {options.map((option) => (
                    <SingleItem
                      key={option.id}
                      item={option as SuggestionSearchBarOptionBase}
                    />
                  ))}
                </Stack>
              </ItemWrapper>
            </Grid2>
            <Grid2 xs={6}>
              <DetailedItem />
            </Grid2>
          </>
        )}
      </Grid2>
    </Styled.Wrapper>
  );
};

OptionsContainer.displayName = 'OptionsContainer';
